import { EPropertyForRentStatus } from "@rentiohq/shared-frontend/dist/types/property.types";
import styled from "@rentiohq/web-theme";
import { PillBase } from "../pill.styles";

interface IForRentSwitchStyleProps {
  forRentStatus: EPropertyForRentStatus;
}

export const ForRentSwitch = styled.div<IForRentSwitchStyleProps>`
  ${PillBase}
  cursor: pointer;
  color: white;
  background-color: ${({ forRentStatus }) =>
    [EPropertyForRentStatus.ForRent, EPropertyForRentStatus.InOption].includes(
      forRentStatus,
    )
      ? "purple"
      : "gray"};
`;
